import { useState } from "react";
import { Input } from "../ui/input";
import { Eye, EyeOff } from "lucide-react";
import { Button } from "../ui/button";
import { ControllerRenderProps } from "react-hook-form";

interface PasswordInputProps {
  field: ControllerRenderProps<
    {
      email: string;
      password: string;
    },
    "password"
  >;
}

export function PasswordInput({ field }: PasswordInputProps) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="relative">
      <Input
        type={showPassword ? "text" : "password"}
        placeholder="Enter your password"
        className="px-4 py-2 pr-10"
        data-lpignore="true"
        {...field}
      />
      <Button
        type="button"
        variant="outline"
        className="absolute inset-y-0 right-0 flex items-center pr-3 rounded-l-none rounded-r bg-gray-50 text-gray-500"
        onClick={() => setShowPassword((prev) => !prev)}
      >
        {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
      </Button>
    </div>
  );
}
